import { APPLICANT_ATTRIBUTION_BOTH } from 'cpool-constants';

import type { SchemaCreditRequestForm } from '../../schemas/creditRequestForm.schema';

type Props = {
    dispositionsKredite: SchemaCreditRequestForm['dispositionskredite'];
    geschaeftsKredite: SchemaCreditRequestForm['geschaeftskredite'];
    kreditKarten: SchemaCreditRequestForm['kreditkarten'];
    ratenKredite: SchemaCreditRequestForm['ratenkredite'];
    sonstigeVerbindlichkeiten: SchemaCreditRequestForm['sonstigeVerbindlichkeiten'];
    dataSnippets: SchemaCreditRequestForm['dataSnippets'];
    coApplicantHidden: boolean;
};

export const getTotalFinancedAmount = (props: Props) => {
    let sum = 0;
    const { coApplicantHidden, dataSnippets, ...credits } = props;

    Object.values(credits).forEach((creditKindArray) => {
        creditKindArray.forEach((credit) => {
            if (
                !credit.abloesen ||
                credit.hide ||
                (dataSnippets?.applicant1?.excludeApplicant &&
                    credit.gehoertZuAntragsteller === APPLICANT_ATTRIBUTION_BOTH.ANTRAGSTELLER_1) ||
                ((dataSnippets?.applicant2?.excludeApplicant || coApplicantHidden) &&
                    credit.gehoertZuAntragsteller === APPLICANT_ATTRIBUTION_BOTH.ANTRAGSTELLER_2)
            )
                return;
            const amount = 'restschuld' in credit ? credit.restschuld : credit.beanspruchterBetrag;
            sum += amount ?? 0;
        });
    });

    return sum;
};
